import { from, of, timer } from "rxjs"
import { ofType } from "redux-observable"
import { switchMap, catchError, mapTo } from "rxjs/operators"
import { push } from "connected-react-router"

import {
    fetchOrganizationsSuccess,
    fetchAccessRightsSuccess,
    selectShipper,
    checkEbolWOAccess,
    checkEbolWOAccessSuccess,
    checkEbolWOAccessFailure,
} from "./actions"

import * as errorActions from "../error/actions"
import { hideLoader } from "../loader/actions"

import { getStoredShipper } from "../../constants/utils"
import userProfileApi from "../../api/user-profile-api"
import * as types from "./actionTypes"
import { fetchAllDashboardData } from "../../redux/dashboard/actions"
import { hideEnhancedVisibilityMenu } from "../../redux/userProfile/actions"

export function openEnhancedVisibilityMenu(action$) {
    return action$.pipe(
        ofType(types.SHOW_ENHANCED_VISIBILITY_MENU),
        switchMap(() => timer(1000).pipe(mapTo(hideEnhancedVisibilityMenu())))
    )
}
export function fetchOrganizationsData(action$) {
    const { STORED_RAILROAD_NAME, STORED_SHIPPER_NAME } = getStoredShipper()
    return action$.pipe(
        ofType(types.FETCH_ORGANIZATIONS_DATA),
        switchMap((action) =>
            from(userProfileApi.getOrganizationsData(action.payload)).pipe(
                switchMap((userProfiledata) =>
                    of(fetchOrganizationsSuccess(userProfiledata))
                ),
                switchMap((userProfiledata) =>
                    from(
                        userProfileApi.getAccessRightsData(
                            userProfiledata.payload
                        )
                    ).pipe(
                        switchMap((userPermissionData) =>
                            of(
                                checkEbolWOAccess(),
                                fetchAccessRightsSuccess(
                                    userPermissionData,
                                    userProfiledata.payload
                                ),
                                selectShipper(
                                    STORED_RAILROAD_NAME && STORED_SHIPPER_NAME
                                        ? JSON.parse(
                                              localStorage.getItem(
                                                  "shipper_details"
                                              )
                                          )
                                        : userProfiledata.payload.filter(
                                              (item) =>
                                                  item.orgType === "Shipper" &&
                                                  item.grantors.length > 0
                                          )[0]
                                ),
                                fetchAllDashboardData(userPermissionData)
                            )
                        ),
                        catchError((error) =>
                            of(
                                push("/error"),
                                errorActions.setError(error),
                                hideLoader()
                            )
                        )
                    )
                ),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}

export function fetchAccessRightsData(action$) {
    return action$.pipe(
        ofType(types.FETCH_ACCESS_RIGHTS),
        switchMap((action) =>
            from(userProfileApi.getAccessRightsData(action.payload)).pipe(
                switchMap((data) =>
                    of(
                        fetchAccessRightsSuccess(data, action.payload),
                        fetchAllDashboardData()
                    )
                ),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}

export function checkEbolWabtecAccess(action$) {
    return action$.pipe(
        ofType(types.CHECK_EBOL_WO_ACCESS),
        switchMap(() =>
            from(userProfileApi.checkEbolAccess()).pipe(
                switchMap((data) => {
                    if (
                        data &&
                        data.permissions &&
                        data.permissions.length > 0
                    ) {
                        return of(checkEbolWOAccessSuccess())
                    } else {
                        return of(checkEbolWOAccessFailure())
                    }
                }),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader(),
                        checkEbolWOAccessFailure()
                    )
                )
            )
        )
    )
}
